import React from "react";
import { Warning, ArrowClockwise } from "@phosphor-icons/react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("Uncaught React Error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-app-bg text-app-text flex flex-col items-center justify-center p-6 font-mono-d select-none">
          <div className="w-full max-w-md bg-app-surface border border-app-border rounded-xl p-6 shadow-2xl space-y-4">
            <div className="flex items-center gap-3">
              <div className="p-2.5 rounded-lg bg-[#FF3B30]/15 text-[#FF3B30] border border-[#FF3B30]/30 shrink-0">
                <Warning size={24} weight="bold" />
              </div>
              <div>
                <h2 className="text-base font-bold uppercase tracking-wider text-app-text">Application Error</h2>
                <p className="text-xs text-app-muted mt-0.5">Something went wrong while rendering this section.</p>
              </div>
            </div>

            {this.state.error && (
              <div className="p-3 bg-app-bg border border-app-border rounded-lg text-xs text-[#FF3B30] overflow-x-auto max-h-32">
                <p className="font-bold">{String(this.state.error?.message || this.state.error)}</p>
              </div>
            )}

            <div className="flex gap-2.5 pt-2">
              <button
                type="button"
                onClick={this.handleReload}
                className="flex-1 py-2.5 px-4 bg-app-accent hover:opacity-90 text-white font-bold text-xs uppercase tracking-wider rounded-md flex items-center justify-center gap-2 transition-colors"
              >
                <ArrowClockwise size={14} weight="bold" /> Reload Page
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="py-2.5 px-4 border border-app-border bg-app-surface hover:bg-app-hover text-app-muted hover:text-app-text font-semibold text-xs uppercase tracking-wider rounded-md transition-colors"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
